module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo11-6b0ea6befda7432790fba3e05e7d001e.jpg";